import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AddEditButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  whiteSpace: "nowrap",
  borderRadius: 0,
  padding: "0px",
}));
